import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	getAll () {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/users', {}).then(function (response) {
				resolve(response)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/models/user/user.js